import { MutableRefObject } from 'react';
import { SportProviders } from 'store/websiteSports';
import useMount from 'hooks/useMount';

const useRewriteAtlasLinks = (atlasWidgetRef: MutableRefObject<HTMLDivElement | null>) => {
  useMount(() => {
    // rewriting atlas widget anchor tags to route to the correct page
    function getDescendants(node, accum = []) {
      if (!node) return accum;
      for (let index = 0; index < node.childNodes.length; index++) {
        node.childNodes[index].tagName === 'A' && accum.push(node.childNodes[index]);
        getDescendants(node.childNodes[index], accum);
      }
      return accum;
    }
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const allLinks = getDescendants(atlasWidgetRef.current);
          allLinks.forEach((link) => {
            const href = link.getAttribute('href');
            if (href) {
              link.removeAttribute('target');
              const [, search] = href.split('?');
              const searchParams = new URLSearchParams(search);
              const matchId = searchParams.get('e');
              if (!matchId || Number.isNaN(Number(matchId))) return;

              const requiredSearchParams = new URLSearchParams();
              requiredSearchParams.set('match', matchId);
              link.setAttribute('href', `/sport/${SportProviders.ATLAS_ID}?${requiredSearchParams.toString()}`);
            }
          });
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(atlasWidgetRef.current, config);

    return () => observer.disconnect();
  });
};

export default useRewriteAtlasLinks;
